import React from 'react';
import { Tooltip, Button } from 'antd';
import Translate from 'react-translate-component';

const getTooltipMessage = isEventEdit => isEventEdit ? 'events.simultaneously_edit' : 'events.fill_required_fields';

export const EventEditButton = ({ isEditable, isEnterResult, isEditEvent, toggleEdit }) => (isEditable && !isEditEvent) ? (
    <div className="p-0-25-25">
        <Tooltip title={isEnterResult && <Translate content="events.simultaneously_edit" />}
                 placement="top"
                 overlayStyle={{ position: "fixed" }}>
            <Button onClick={toggleEdit} disabled={isEnterResult}>
                <Translate content="events.edit" />
            </Button>
        </Tooltip>
    </div>
) : null;

export const EditResultButton = ({ isEditEvent, toggleResult, isResultNotAllowed }) => (
    <div className="panel-view">
        <Tooltip title={isResultNotAllowed && <Translate content={getTooltipMessage(isEditEvent)} />}
                 placement="top"
                 overlayStyle={{ position: "fixed" }}>
            <Button onClick={toggleResult} disabled={isResultNotAllowed}>
                <Translate content='events.enterResult' />
            </Button>
        </Tooltip>
    </div>
);
